import { AfterViewInit, Component, Input, inject } from '@angular/core';
import { ElementComponent } from '../element-wyswyg/element-wyswyg.component';
import { ScrollService } from 'src/app/shared/services/scroll.service';
import { Subject, distinctUntilChanged } from 'rxjs';
import { EventsWyswygService } from 'src/app/shared/services/events-wyswyg.service';

@Component({
  selector: 'quiz-wyswyg',
  templateUrl: './quiz-wyswyg.component.html',
  styleUrls: ['./quiz-wyswyg.component.css']
})
export class QuizWyswygComponent extends ElementComponent implements AfterViewInit {

  correctionMode: boolean = false;
  focusMode: boolean = false;

  @Input() override data: any =
    {
      question: 'Enunciado',
      test: true,
      answers: [
        { id: 0, text: "Opción 1", correct: false },
        { id: 1, text: "Opción 2", correct: false },
      ],
      sent: false
    }

    private scrollService: ScrollService;
    private inputSubject = new Subject<any>();

    constructor(
      private eventsService: EventsWyswygService
    ) {
      super()
      this.scrollService = inject(ScrollService);
      this.inputSubject.pipe(
        distinctUntilChanged()
      ).subscribe(({target, index}) => {
        if (target.value === "") {
          this.data.answers[index].text = "Opción "+(index+1);
        }
      });
    }

    ngAfterViewInit(): void {
      this.checkIsCorrectionMissing();
    }

    onNewAnswerInput() {
      this.addAnswer();

      setTimeout(() => {
        this.scrollService.selectElementById(this.data.prefix+'-'+(this.data.answers.length-1)+'answer');
      },0)
    }

    checkAnswerEmpty(event, i): void {
      this.inputSubject.next({target: event.target, index: i});
    }

    addAnswer(): void {
      if (this.data.answers.length >= 10) return;
      this.data.answers.push({ id: this.data.answers.length, text: "Opción "+(this.data.answers.length+1), correct: false });
    }

    deleteAnswer(index: number): void {
      if (this.data.answers.length <= 2) return;

      this.data.answers.splice(index, 1);
      this.checkIsCorrectionMissing()
    }

    checkIsCorrectionMissing() {
      if (!this.data.test) {
        this.focusMode = false;
        this.eventsService.emitFocusMode(false);
        return;
      }

      for (let answer of this.data.answers) {
        if (answer.correct) {
          this.focusMode = false;
          this.eventsService.emitFocusMode(false);
          return;
        }
      }

      this.scrollService.scrollToElementById(this.data.prefix+'-quiz');
      this.eventsService.emitFocusMode(true);
      return this.focusMode = true;
    }

}
